export type GuestSyncMessage =
  | {
      type: 'guests-updated';
      version: number;
      updatedAt: string;
    }
  | {
      type: 'reload-request';
    };

const CHANNEL_NAME = 'wzw-guest-sync';

class GuestSyncChannel {
  private channel: BroadcastChannel | null = null;

  public constructor() {
    if (typeof BroadcastChannel !== 'undefined') {
      this.channel = new BroadcastChannel(CHANNEL_NAME);
    }
  }

  public notifyUpdated(version: number, updatedAt: string): void {
    this.channel?.postMessage({
      type: 'guests-updated',
      version,
      updatedAt,
    } satisfies GuestSyncMessage);
  }

  public requestReload(): void {
    this.channel?.postMessage({
      type: 'reload-request',
    } satisfies GuestSyncMessage);
  }

  public subscribe(handler: (message: GuestSyncMessage) => void): () => void {
    if (!this.channel) {
      return () => undefined;
    }

    const listener = (event: MessageEvent<GuestSyncMessage>) => {
      handler(event.data);
    };

    this.channel.addEventListener('message', listener);

    return () => {
      this.channel?.removeEventListener('message', listener);
    };
  }

  public close(): void {
    this.channel?.close();
    this.channel = null;
  }
}

export const guestSyncChannel = new GuestSyncChannel();
